import { Loader2 } from "lucide-react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { SimiFormData } from "../types";

type SimiErpFormProps = {
  formData: SimiFormData;
  onFormDataChange: (data: Partial<SimiFormData>) => void;
  existingConfig: { hasAdminCredentials: boolean } | null;
  isLoading: boolean;
  onSave: () => void;
};

const SENSITIVE_HINT = "Deja en blanco para mantener el valor actual, o ingresa uno nuevo para actualizar";

const SimiErpForm = ({
  formData,
  onFormDataChange,
  existingConfig,
  isLoading,
  onSave,
}: SimiErpFormProps): JSX.Element => {
  return (
    <div className="rounded-xl border border-gray-200 bg-white p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-gray-900">Credenciales SIMI</h3>
        {existingConfig?.hasAdminCredentials && (
          <span className="text-sm font-medium text-green-600">Conexion exitosa</span>
        )}
      </div>
      <div className="flex flex-col gap-4">
        <div>
          <Label className="text-sm font-medium text-gray-700 mb-1.5 block">Usuario Admin</Label>
          <Input
            type="text"
            placeholder={existingConfig?.hasAdminCredentials ? "••••••••" : "Usuario administrador"}
            value={formData.usernameAdmin}
            onChange={(e) => onFormDataChange({ usernameAdmin: e.target.value })}
            className="bg-gray-50 hover:border-gray-300 focus:border-purple-500 focus:bg-white"
          />
          {existingConfig?.hasAdminCredentials && (
            <p className="mt-1 text-xs text-gray-500">{SENSITIVE_HINT}</p>
          )}
        </div>
        <div>
          <Label className="text-sm font-medium text-gray-700 mb-1.5 block">Contrasena Admin</Label>
          <Input
            type="password"
            placeholder={existingConfig?.hasAdminCredentials ? "••••••••" : "Contrasena de administrador"}
            value={formData.passwordAdmin}
            onChange={(e) => onFormDataChange({ passwordAdmin: e.target.value })}
            className="bg-gray-50 hover:border-gray-300 focus:border-purple-500 focus:bg-white"
          />
          {existingConfig?.hasAdminCredentials && (
            <p className="mt-1 text-xs text-gray-500">{SENSITIVE_HINT}</p>
          )}
        </div>
        <div className="pt-2">
          <Button variant="main" onClick={onSave} disabled={isLoading}>
            {isLoading && <Loader2 className="mr-2 size-4 animate-spin" />}
            Guardar
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SimiErpForm;
